import React, {useContext} from 'react'
import {Button, Popconfirm} from "antd";
import {RecipeConText} from "../../../../../context/RecipeContext";


const RecipeItemDelete = ({rowId}) => {

    const {rowData} = useContext(RecipeConText)
    const [rowState, setRowState] = rowData

    const handleDeleteClick = () => {
            let mockRows = Object.assign({}, rowState)
            delete mockRows[rowId]

            setRowState(mockRows)
    }

    return(
        <React.Fragment>
            <Popconfirm
                title={'Silmek istediğinize emin misiniz ?'}
                okText={'SİL'}
                cancelText={'VAZGEÇ'}
                okButtonProps={{type: 'danger'}}
                onConfirm={handleDeleteClick}
            >
                <Button
                    type={'link'}
                    danger
                >
                    Sil
                </Button>
            </Popconfirm>
        </React.Fragment>
    )
}
export default RecipeItemDelete